<template>
  <div
    class="market-list-item-v2-embed"
    :class="{ 'market-list-item-v2-embed--vertical': isVerticalList }"
  >
    <div class="market-list-item-v2-embed__header" v-if="showTitle">
      <div class="market-list-item-v2-embed__header-text">Related Markets:</div>
      <div class="market-list-item-v2-embed__header-text--small">
        {{ markets.length }} Market<template v-if="markets.length !== 1">s</template>
      </div>
    </div>
    <div class="market-list-item-v2-embed__grid" :style="gridStyleModifiers">
      <div class="market-list-item-v2-embed__grid-item" v-for="market in markets">
        <market-list-item
          :key="market.marketId"
          :market="market"
          :trackingContext="trackingContext"
        ></market-list-item>
      </div>
    </div>
  </div>
</template>

<script src="./market-list-item-v2-embed.js"></script>
<style src="./market-list-item-v2-embed.scss" lang="scss"></style>
